import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { REVENUE_DATA_ERROR, GETTING_REVENUE_DATA, GET_REVENUE_DATA, GET_FINANCE_DATA, GETTING_FINANCE_DATA, FINANCE_DATA_ERROR } from "../types"

export const fetchRevenueData = (period = 'monthly') => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: GETTING_REVENUE_DATA,
            payload: true
        })

        const response = await axios.get(`${baseUrl}/dashboards/revenue-by-period?period=${period}`, { headers })
        
        dispatch({
            type: GET_REVENUE_DATA,
            payload: {
                data: response.data.data.data,
                period: response.data.data.period
            }
        })
        
    }
    catch(error){
        dispatch({
            type: REVENUE_DATA_ERROR,
            error
        })
    }
}

export const fetchFinanceData = () => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: GETTING_FINANCE_DATA,
            payload: true
        })

        const response = await axios.get(`${baseUrl}/dashboards/finance`, { headers })
        
        dispatch({
            type: GET_FINANCE_DATA,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: FINANCE_DATA_ERROR,
            error
        })
    }
}
